
      var $parcel$global = globalThis;
    'use strict';
var $5e9b0df860d70ad6$exports = {};
'use strict';
var $dcdc9b526aa3d25a$exports = {};
'use strict';
$dcdc9b526aa3d25a$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$5e9b0df860d70ad6$exports = !$dcdc9b526aa3d25a$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $42a99fbba5c80341$exports = {};
'use strict';
var $2305b304023a3128$exports = {};
'use strict';
var $4a940c070be3b3fa$exports = {};
'use strict';
var $d032db0c6aa5b506$exports = {};
'use strict';

$d032db0c6aa5b506$exports = !$dcdc9b526aa3d25a$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $4a940c070be3b3fa$var$FunctionPrototype = Function.prototype;
var $4a940c070be3b3fa$var$call = $4a940c070be3b3fa$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $4a940c070be3b3fa$var$uncurryThisWithBind = $d032db0c6aa5b506$exports && $4a940c070be3b3fa$var$FunctionPrototype.bind.bind($4a940c070be3b3fa$var$call, $4a940c070be3b3fa$var$call);
$4a940c070be3b3fa$exports = $d032db0c6aa5b506$exports ? $4a940c070be3b3fa$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $4a940c070be3b3fa$var$call.apply(fn, arguments);
    };
};



var $d3b5c54e0efe4919$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $d3b5c54e0efe4919$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$d3b5c54e0efe4919$exports = typeof $d3b5c54e0efe4919$var$documentAll == 'undefined' && $d3b5c54e0efe4919$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $d3b5c54e0efe4919$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


var $44f04f053c39977d$exports = {};
'use strict';

var $d4c1256ef47a4432$exports = {};
'use strict';
var $09e988ba29a98f9f$exports = {};
'use strict';
var $9e6b79f708b41678$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$9e6b79f708b41678$exports = function(it) {
    return it === null || it === undefined;
};


var $09e988ba29a98f9f$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$09e988ba29a98f9f$exports = function(it) {
    if ($9e6b79f708b41678$exports(it)) throw new $09e988ba29a98f9f$var$$TypeError("Can't call method on " + it);
    return it;
};


var $d4c1256ef47a4432$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$d4c1256ef47a4432$exports = function(argument) {
    return $d4c1256ef47a4432$var$$Object($09e988ba29a98f9f$exports(argument));
};


var $44f04f053c39977d$var$hasOwnProperty = $4a940c070be3b3fa$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$44f04f053c39977d$exports = Object.hasOwn || function hasOwn(it, key) {
    return $44f04f053c39977d$var$hasOwnProperty($d4c1256ef47a4432$exports(it), key);
};



var $49cc0544117e8ea3$exports = {};
'use strict';


var $49cc0544117e8ea3$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $49cc0544117e8ea3$var$getDescriptor = $5e9b0df860d70ad6$exports && Object.getOwnPropertyDescriptor;
var $49cc0544117e8ea3$var$EXISTS = $44f04f053c39977d$exports($49cc0544117e8ea3$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $49cc0544117e8ea3$var$PROPER = $49cc0544117e8ea3$var$EXISTS && (function something() {}).name === 'something';
var $49cc0544117e8ea3$var$CONFIGURABLE = $49cc0544117e8ea3$var$EXISTS && (!$5e9b0df860d70ad6$exports || $5e9b0df860d70ad6$exports && $49cc0544117e8ea3$var$getDescriptor($49cc0544117e8ea3$var$FunctionPrototype, 'name').configurable);
$49cc0544117e8ea3$exports = {
    EXISTS: $49cc0544117e8ea3$var$EXISTS,
    PROPER: $49cc0544117e8ea3$var$PROPER,
    CONFIGURABLE: $49cc0544117e8ea3$var$CONFIGURABLE
};


var $2305b304023a3128$require$CONFIGURABLE_FUNCTION_NAME = $49cc0544117e8ea3$exports.CONFIGURABLE;
var $8f94c74aec3eeb84$exports = {};
'use strict';


var $0d1c61aa4e10d728$exports = {};
'use strict';
var $1d277a19a39313e8$exports = {};
'use strict';
$1d277a19a39313e8$exports = false;


var $02854e3ff22e2a55$exports = {};
'use strict';
var $02854e3ff22e2a55$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$02854e3ff22e2a55$exports = // eslint-disable-next-line es/no-global-this -- safe
$02854e3ff22e2a55$var$check(typeof globalThis == 'object' && globalThis) || $02854e3ff22e2a55$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$02854e3ff22e2a55$var$check(typeof self == 'object' && self) || $02854e3ff22e2a55$var$check(typeof $parcel$global == 'object' && $parcel$global) || $02854e3ff22e2a55$var$check(typeof $02854e3ff22e2a55$exports == 'object' && $02854e3ff22e2a55$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $442d0e1485853cf0$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $442d0e1485853cf0$var$defineProperty = Object.defineProperty;
$442d0e1485853cf0$exports = function(key, value) {
    try {
        $442d0e1485853cf0$var$defineProperty($02854e3ff22e2a55$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $02854e3ff22e2a55$exports[key] = value;
    }
    return value;
};


var $0d1c61aa4e10d728$var$SHARED = '__core-js_shared__';
var $0d1c61aa4e10d728$var$store = $0d1c61aa4e10d728$exports = $02854e3ff22e2a55$exports[$0d1c61aa4e10d728$var$SHARED] || $442d0e1485853cf0$exports($0d1c61aa4e10d728$var$SHARED, {});
($0d1c61aa4e10d728$var$store.versions || ($0d1c61aa4e10d728$var$store.versions = [])).push({
    version: '3.47.0',
    mode: $1d277a19a39313e8$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: 'https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


var $8f94c74aec3eeb84$var$functionToString = $4a940c070be3b3fa$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$d3b5c54e0efe4919$exports($0d1c61aa4e10d728$exports.inspectSource)) $0d1c61aa4e10d728$exports.inspectSource = function(it) {
    return $8f94c74aec3eeb84$var$functionToString(it);
};
$8f94c74aec3eeb84$exports = $0d1c61aa4e10d728$exports.inspectSource;


var $d8e7bce4c49bb817$exports = {};
'use strict';
var $b523cc57853d1449$exports = {};
'use strict';


var $b523cc57853d1449$var$WeakMap = $02854e3ff22e2a55$exports.WeakMap;
$b523cc57853d1449$exports = $d3b5c54e0efe4919$exports($b523cc57853d1449$var$WeakMap) && /native code/.test(String($b523cc57853d1449$var$WeakMap));



var $b5ebf59d5dccfd91$exports = {};
'use strict';

$b5ebf59d5dccfd91$exports = function(it) {
    return typeof it == 'object' ? it !== null : $d3b5c54e0efe4919$exports(it);
};


var $4bb99da2275f3503$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $7e4e8568fa191380$export$2d1720544b23b823;
'use strict';

var $a12e0a77a176b2e4$exports = {};
'use strict';


var $ab2fc4bb10b030dd$exports = {};
'use strict';


var $ab2fc4bb10b030dd$var$document = $02854e3ff22e2a55$exports.document;
// typeof document.createElement is 'object' in old IE
var $ab2fc4bb10b030dd$var$EXISTS = $b5ebf59d5dccfd91$exports($ab2fc4bb10b030dd$var$document) && $b5ebf59d5dccfd91$exports($ab2fc4bb10b030dd$var$document.createElement);
$ab2fc4bb10b030dd$exports = function(it) {
    return $ab2fc4bb10b030dd$var$EXISTS ? $ab2fc4bb10b030dd$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$a12e0a77a176b2e4$exports = !$5e9b0df860d70ad6$exports && !$dcdc9b526aa3d25a$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($ab2fc4bb10b030dd$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $b8667b23d3241991$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$b8667b23d3241991$exports = $5e9b0df860d70ad6$exports && $dcdc9b526aa3d25a$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $230d61f7a8553bc0$exports = {};
'use strict';

var $230d61f7a8553bc0$var$$String = String;
var $230d61f7a8553bc0$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$230d61f7a8553bc0$exports = function(argument) {
    if ($b5ebf59d5dccfd91$exports(argument)) return argument;
    throw new $230d61f7a8553bc0$var$$TypeError($230d61f7a8553bc0$var$$String(argument) + ' is not an object');
};


var $e22b43ffdc0ae7fb$exports = {};
'use strict';
var $b34acb1eb091cced$exports = {};
'use strict';
var $24f8e13787a29057$exports = {};
'use strict';

var $24f8e13787a29057$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$24f8e13787a29057$exports = $d032db0c6aa5b506$exports ? $24f8e13787a29057$var$call.bind($24f8e13787a29057$var$call) : function() {
    return $24f8e13787a29057$var$call.apply($24f8e13787a29057$var$call, arguments);
};



var $345d425c72ebe925$exports = {};
'use strict';
var $6b8917f51b0da2d4$exports = {};
'use strict';


var $6b8917f51b0da2d4$var$aFunction = function(argument) {
    return $d3b5c54e0efe4919$exports(argument) ? argument : undefined;
};
$6b8917f51b0da2d4$exports = function(namespace, method) {
    return arguments.length < 2 ? $6b8917f51b0da2d4$var$aFunction($02854e3ff22e2a55$exports[namespace]) : $02854e3ff22e2a55$exports[namespace] && $02854e3ff22e2a55$exports[namespace][method];
};



var $082e275852b092c6$exports = {};
'use strict';

$082e275852b092c6$exports = $4a940c070be3b3fa$exports({}.isPrototypeOf);


var $ed59daaa315e1e0f$exports = {};
'use strict';
var $f7cef0e6386c4076$exports = {};
'use strict';
var $a26d76ee5bdbac6a$exports = {};
'use strict';

var $4650ad1f1223221a$exports = {};
'use strict';

var $4650ad1f1223221a$var$navigator = $02854e3ff22e2a55$exports.navigator;
var $4650ad1f1223221a$var$userAgent = $4650ad1f1223221a$var$navigator && $4650ad1f1223221a$var$navigator.userAgent;
$4650ad1f1223221a$exports = $4650ad1f1223221a$var$userAgent ? String($4650ad1f1223221a$var$userAgent) : '';


var $a26d76ee5bdbac6a$var$process = $02854e3ff22e2a55$exports.process;
var $a26d76ee5bdbac6a$var$Deno = $02854e3ff22e2a55$exports.Deno;
var $a26d76ee5bdbac6a$var$versions = $a26d76ee5bdbac6a$var$process && $a26d76ee5bdbac6a$var$process.versions || $a26d76ee5bdbac6a$var$Deno && $a26d76ee5bdbac6a$var$Deno.version;
var $a26d76ee5bdbac6a$var$v8 = $a26d76ee5bdbac6a$var$versions && $a26d76ee5bdbac6a$var$versions.v8;
var $a26d76ee5bdbac6a$var$match, $a26d76ee5bdbac6a$var$version;
if ($a26d76ee5bdbac6a$var$v8) {
    $a26d76ee5bdbac6a$var$match = $a26d76ee5bdbac6a$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $a26d76ee5bdbac6a$var$version = $a26d76ee5bdbac6a$var$match[0] > 0 && $a26d76ee5bdbac6a$var$match[0] < 4 ? 1 : +($a26d76ee5bdbac6a$var$match[0] + $a26d76ee5bdbac6a$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$a26d76ee5bdbac6a$var$version && $4650ad1f1223221a$exports) {
    $a26d76ee5bdbac6a$var$match = $4650ad1f1223221a$exports.match(/Edge\/(\d+)/);
    if (!$a26d76ee5bdbac6a$var$match || $a26d76ee5bdbac6a$var$match[1] >= 74) {
        $a26d76ee5bdbac6a$var$match = $4650ad1f1223221a$exports.match(/Chrome\/(\d+)/);
        if ($a26d76ee5bdbac6a$var$match) $a26d76ee5bdbac6a$var$version = +$a26d76ee5bdbac6a$var$match[1];
    }
}
$a26d76ee5bdbac6a$exports = $a26d76ee5bdbac6a$var$version;




var $f7cef0e6386c4076$var$$String = $02854e3ff22e2a55$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$f7cef0e6386c4076$exports = !!Object.getOwnPropertySymbols && !$dcdc9b526aa3d25a$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$f7cef0e6386c4076$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $a26d76ee5bdbac6a$exports && $a26d76ee5bdbac6a$exports < 41;
});


$ed59daaa315e1e0f$exports = $f7cef0e6386c4076$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $345d425c72ebe925$var$$Object = Object;
$345d425c72ebe925$exports = $ed59daaa315e1e0f$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $6b8917f51b0da2d4$exports('Symbol');
    return $d3b5c54e0efe4919$exports($Symbol) && $082e275852b092c6$exports($Symbol.prototype, $345d425c72ebe925$var$$Object(it));
};


var $c26b5c9ce603aa04$exports = {};
'use strict';
var $a2ba8ab9c7ca0870$exports = {};
'use strict';

var $3c5c57d684aab1bf$exports = {};
'use strict';
var $3c5c57d684aab1bf$var$$String = String;
$3c5c57d684aab1bf$exports = function(argument) {
    try {
        return $3c5c57d684aab1bf$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $a2ba8ab9c7ca0870$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$a2ba8ab9c7ca0870$exports = function(argument) {
    if ($d3b5c54e0efe4919$exports(argument)) return argument;
    throw new $a2ba8ab9c7ca0870$var$$TypeError($3c5c57d684aab1bf$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$c26b5c9ce603aa04$exports = function(V, P) {
    var func = V[P];
    return $9e6b79f708b41678$exports(func) ? undefined : $a2ba8ab9c7ca0870$exports(func);
};


var $a16c443133f9bbd7$exports = {};
'use strict';



var $a16c443133f9bbd7$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$a16c443133f9bbd7$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $d3b5c54e0efe4919$exports(fn = input.toString) && !$b5ebf59d5dccfd91$exports(val = $24f8e13787a29057$exports(fn, input))) return val;
    if ($d3b5c54e0efe4919$exports(fn = input.valueOf) && !$b5ebf59d5dccfd91$exports(val = $24f8e13787a29057$exports(fn, input))) return val;
    if (pref !== 'string' && $d3b5c54e0efe4919$exports(fn = input.toString) && !$b5ebf59d5dccfd91$exports(val = $24f8e13787a29057$exports(fn, input))) return val;
    throw new $a16c443133f9bbd7$var$$TypeError("Can't convert object to primitive value");
};


var $4070132752d4af22$exports = {};
'use strict';

var $585c1bdbf44e0cc0$exports = {};
'use strict';

$585c1bdbf44e0cc0$exports = function(key, value) {
    return $0d1c61aa4e10d728$exports[key] || ($0d1c61aa4e10d728$exports[key] = value || {});
};



var $abec29a2cb7de69c$exports = {};
'use strict';

var $abec29a2cb7de69c$var$id = 0;
var $abec29a2cb7de69c$var$postfix = Math.random();
var $abec29a2cb7de69c$var$toString = $4a940c070be3b3fa$exports(1.1.toString);
$abec29a2cb7de69c$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $abec29a2cb7de69c$var$toString(++$abec29a2cb7de69c$var$id + $abec29a2cb7de69c$var$postfix, 36);
};




var $4070132752d4af22$var$Symbol = $02854e3ff22e2a55$exports.Symbol;
var $4070132752d4af22$var$WellKnownSymbolsStore = $585c1bdbf44e0cc0$exports('wks');
var $4070132752d4af22$var$createWellKnownSymbol = $ed59daaa315e1e0f$exports ? $4070132752d4af22$var$Symbol['for'] || $4070132752d4af22$var$Symbol : $4070132752d4af22$var$Symbol && $4070132752d4af22$var$Symbol.withoutSetter || $abec29a2cb7de69c$exports;
$4070132752d4af22$exports = function(name) {
    if (!$44f04f053c39977d$exports($4070132752d4af22$var$WellKnownSymbolsStore, name)) $4070132752d4af22$var$WellKnownSymbolsStore[name] = $f7cef0e6386c4076$exports && $44f04f053c39977d$exports($4070132752d4af22$var$Symbol, name) ? $4070132752d4af22$var$Symbol[name] : $4070132752d4af22$var$createWellKnownSymbol('Symbol.' + name);
    return $4070132752d4af22$var$WellKnownSymbolsStore[name];
};


var $b34acb1eb091cced$var$$TypeError = TypeError;
var $b34acb1eb091cced$var$TO_PRIMITIVE = $4070132752d4af22$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$b34acb1eb091cced$exports = function(input, pref) {
    if (!$b5ebf59d5dccfd91$exports(input) || $345d425c72ebe925$exports(input)) return input;
    var exoticToPrim = $c26b5c9ce603aa04$exports(input, $b34acb1eb091cced$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $24f8e13787a29057$exports(exoticToPrim, input, pref);
        if (!$b5ebf59d5dccfd91$exports(result) || $345d425c72ebe925$exports(result)) return result;
        throw new $b34acb1eb091cced$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $a16c443133f9bbd7$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$e22b43ffdc0ae7fb$exports = function(argument) {
    var key = $b34acb1eb091cced$exports(argument, 'string');
    return $345d425c72ebe925$exports(key) ? key : key + '';
};


var $7e4e8568fa191380$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7e4e8568fa191380$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7e4e8568fa191380$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7e4e8568fa191380$var$ENUMERABLE = 'enumerable';
var $7e4e8568fa191380$var$CONFIGURABLE = 'configurable';
var $7e4e8568fa191380$var$WRITABLE = 'writable';
$7e4e8568fa191380$export$2d1720544b23b823 = $5e9b0df860d70ad6$exports ? $b8667b23d3241991$exports ? function defineProperty(O, P, Attributes) {
    $230d61f7a8553bc0$exports(O);
    P = $e22b43ffdc0ae7fb$exports(P);
    $230d61f7a8553bc0$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $7e4e8568fa191380$var$WRITABLE in Attributes && !Attributes[$7e4e8568fa191380$var$WRITABLE]) {
        var current = $7e4e8568fa191380$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$7e4e8568fa191380$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $7e4e8568fa191380$var$CONFIGURABLE in Attributes ? Attributes[$7e4e8568fa191380$var$CONFIGURABLE] : current[$7e4e8568fa191380$var$CONFIGURABLE],
                enumerable: $7e4e8568fa191380$var$ENUMERABLE in Attributes ? Attributes[$7e4e8568fa191380$var$ENUMERABLE] : current[$7e4e8568fa191380$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $7e4e8568fa191380$var$$defineProperty(O, P, Attributes);
} : $7e4e8568fa191380$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $230d61f7a8553bc0$exports(O);
    P = $e22b43ffdc0ae7fb$exports(P);
    $230d61f7a8553bc0$exports(Attributes);
    if ($a12e0a77a176b2e4$exports) try {
        return $7e4e8568fa191380$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $7e4e8568fa191380$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};


var $cfed81556fccc500$exports = {};
'use strict';
$cfed81556fccc500$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$4bb99da2275f3503$exports = $5e9b0df860d70ad6$exports ? function(object, key, value) {
    return $7e4e8568fa191380$export$2d1720544b23b823(object, key, $cfed81556fccc500$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $1e0cfb1ef2f8f999$exports = {};
'use strict';


var $1e0cfb1ef2f8f999$var$keys = $585c1bdbf44e0cc0$exports('keys');
$1e0cfb1ef2f8f999$exports = function(key) {
    return $1e0cfb1ef2f8f999$var$keys[key] || ($1e0cfb1ef2f8f999$var$keys[key] = $abec29a2cb7de69c$exports(key));
};


var $5da105f505494238$exports = {};
'use strict';
$5da105f505494238$exports = {};


var $d8e7bce4c49bb817$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $d8e7bce4c49bb817$var$TypeError = $02854e3ff22e2a55$exports.TypeError;
var $d8e7bce4c49bb817$var$WeakMap = $02854e3ff22e2a55$exports.WeakMap;
var $d8e7bce4c49bb817$var$set, $d8e7bce4c49bb817$var$get, $d8e7bce4c49bb817$var$has;
var $d8e7bce4c49bb817$var$enforce = function(it) {
    return $d8e7bce4c49bb817$var$has(it) ? $d8e7bce4c49bb817$var$get(it) : $d8e7bce4c49bb817$var$set(it, {});
};
var $d8e7bce4c49bb817$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$b5ebf59d5dccfd91$exports(it) || (state = $d8e7bce4c49bb817$var$get(it)).type !== TYPE) throw new $d8e7bce4c49bb817$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($b523cc57853d1449$exports || $0d1c61aa4e10d728$exports.state) {
    var $d8e7bce4c49bb817$var$store = $0d1c61aa4e10d728$exports.state || ($0d1c61aa4e10d728$exports.state = new $d8e7bce4c49bb817$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $d8e7bce4c49bb817$var$store.get = $d8e7bce4c49bb817$var$store.get;
    $d8e7bce4c49bb817$var$store.has = $d8e7bce4c49bb817$var$store.has;
    $d8e7bce4c49bb817$var$store.set = $d8e7bce4c49bb817$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $d8e7bce4c49bb817$var$set = function(it, metadata) {
        if ($d8e7bce4c49bb817$var$store.has(it)) throw new $d8e7bce4c49bb817$var$TypeError($d8e7bce4c49bb817$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $d8e7bce4c49bb817$var$store.set(it, metadata);
        return metadata;
    };
    $d8e7bce4c49bb817$var$get = function(it) {
        return $d8e7bce4c49bb817$var$store.get(it) || {};
    };
    $d8e7bce4c49bb817$var$has = function(it) {
        return $d8e7bce4c49bb817$var$store.has(it);
    };
} else {
    var $d8e7bce4c49bb817$var$STATE = $1e0cfb1ef2f8f999$exports('state');
    $5da105f505494238$exports[$d8e7bce4c49bb817$var$STATE] = true;
    $d8e7bce4c49bb817$var$set = function(it, metadata) {
        if ($44f04f053c39977d$exports(it, $d8e7bce4c49bb817$var$STATE)) throw new $d8e7bce4c49bb817$var$TypeError($d8e7bce4c49bb817$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $4bb99da2275f3503$exports(it, $d8e7bce4c49bb817$var$STATE, metadata);
        return metadata;
    };
    $d8e7bce4c49bb817$var$get = function(it) {
        return $44f04f053c39977d$exports(it, $d8e7bce4c49bb817$var$STATE) ? it[$d8e7bce4c49bb817$var$STATE] : {};
    };
    $d8e7bce4c49bb817$var$has = function(it) {
        return $44f04f053c39977d$exports(it, $d8e7bce4c49bb817$var$STATE);
    };
}
$d8e7bce4c49bb817$exports = {
    set: $d8e7bce4c49bb817$var$set,
    get: $d8e7bce4c49bb817$var$get,
    has: $d8e7bce4c49bb817$var$has,
    enforce: $d8e7bce4c49bb817$var$enforce,
    getterFor: $d8e7bce4c49bb817$var$getterFor
};


var $2305b304023a3128$var$enforceInternalState = $d8e7bce4c49bb817$exports.enforce;
var $2305b304023a3128$var$getInternalState = $d8e7bce4c49bb817$exports.get;
var $2305b304023a3128$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2305b304023a3128$var$defineProperty = Object.defineProperty;
var $2305b304023a3128$var$stringSlice = $4a940c070be3b3fa$exports(''.slice);
var $2305b304023a3128$var$replace = $4a940c070be3b3fa$exports(''.replace);
var $2305b304023a3128$var$join = $4a940c070be3b3fa$exports([].join);
var $2305b304023a3128$var$CONFIGURABLE_LENGTH = $5e9b0df860d70ad6$exports && !$dcdc9b526aa3d25a$exports(function() {
    return $2305b304023a3128$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $2305b304023a3128$var$TEMPLATE = String(String).split('String');
var $2305b304023a3128$var$makeBuiltIn = $2305b304023a3128$exports = function(value, name, options) {
    if ($2305b304023a3128$var$stringSlice($2305b304023a3128$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $2305b304023a3128$var$replace($2305b304023a3128$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$44f04f053c39977d$exports(value, 'name') || $2305b304023a3128$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($5e9b0df860d70ad6$exports) $2305b304023a3128$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($2305b304023a3128$var$CONFIGURABLE_LENGTH && options && $44f04f053c39977d$exports(options, 'arity') && value.length !== options.arity) $2305b304023a3128$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $44f04f053c39977d$exports(options, 'constructor') && options.constructor) {
            if ($5e9b0df860d70ad6$exports) $2305b304023a3128$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $2305b304023a3128$var$enforceInternalState(value);
    if (!$44f04f053c39977d$exports(state, 'source')) state.source = $2305b304023a3128$var$join($2305b304023a3128$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $2305b304023a3128$var$makeBuiltIn(function toString() {
    return $d3b5c54e0efe4919$exports(this) && $2305b304023a3128$var$getInternalState(this).source || $8f94c74aec3eeb84$exports(this);
}, 'toString');



$42a99fbba5c80341$exports = function(target, name, descriptor) {
    if (descriptor.get) $2305b304023a3128$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $2305b304023a3128$exports(descriptor.set, name, {
        setter: true
    });
    return $7e4e8568fa191380$export$2d1720544b23b823(target, name, descriptor);
};


var $1a0d045619694991$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $1a0d045619694991$var$RegExp = $02854e3ff22e2a55$exports.RegExp;
var $1a0d045619694991$var$FLAGS_GETTER_IS_CORRECT = !$dcdc9b526aa3d25a$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $1a0d045619694991$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($1a0d045619694991$var$RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
$1a0d045619694991$exports = {
    correct: $1a0d045619694991$var$FLAGS_GETTER_IS_CORRECT
};


var $d62d205861c689b8$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$d62d205861c689b8$exports = function() {
    var that = $230d61f7a8553bc0$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($5e9b0df860d70ad6$exports && !$1a0d045619694991$exports.correct) {
    $42a99fbba5c80341$exports(RegExp.prototype, 'flags', {
        configurable: true,
        get: $d62d205861c689b8$exports
    });
    $1a0d045619694991$exports.correct = true;
}


'use strict';


var $6b44d9a5e116ad16$exports = {};
'use strict';
var $fb81e91581bab94d$exports = {};
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
$fb81e91581bab94d$exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';







var $39a5e64497965203$exports = {};
'use strict';
var $e3f002406a8af509$exports = {};
'use strict';

var $e3f002406a8af509$var$TO_STRING_TAG = $4070132752d4af22$exports('toStringTag');
var $e3f002406a8af509$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$e3f002406a8af509$var$test[$e3f002406a8af509$var$TO_STRING_TAG] = 'z';
$e3f002406a8af509$exports = String($e3f002406a8af509$var$test) === '[object z]';



var $152aec1d51d07892$exports = {};
'use strict';

var $152aec1d51d07892$var$toString = $4a940c070be3b3fa$exports({}.toString);
var $152aec1d51d07892$var$stringSlice = $4a940c070be3b3fa$exports(''.slice);
$152aec1d51d07892$exports = function(it) {
    return $152aec1d51d07892$var$stringSlice($152aec1d51d07892$var$toString(it), 8, -1);
};



var $39a5e64497965203$var$TO_STRING_TAG = $4070132752d4af22$exports('toStringTag');
var $39a5e64497965203$var$$Object = Object;
// ES3 wrong here
var $39a5e64497965203$var$CORRECT_ARGUMENTS = $152aec1d51d07892$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $39a5e64497965203$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$39a5e64497965203$exports = $e3f002406a8af509$exports ? $152aec1d51d07892$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $39a5e64497965203$var$tryGet(O = $39a5e64497965203$var$$Object(it), $39a5e64497965203$var$TO_STRING_TAG)) == 'string' ? tag : $39a5e64497965203$var$CORRECT_ARGUMENTS ? $152aec1d51d07892$exports(O) : (result = $152aec1d51d07892$exports(O)) === 'Object' && $d3b5c54e0efe4919$exports(O.callee) ? 'Arguments' : result;
};




var $ed089d2627805a57$exports = {};
'use strict';




$ed089d2627805a57$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($d3b5c54e0efe4919$exports(value)) $2305b304023a3128$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $442d0e1485853cf0$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $7e4e8568fa191380$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $01f60deec1a7fee5$exports = {};
'use strict';




var $ec6e227787d168e3$exports = {};
'use strict';

$ec6e227787d168e3$exports = !$dcdc9b526aa3d25a$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $01f60deec1a7fee5$var$IE_PROTO = $1e0cfb1ef2f8f999$exports('IE_PROTO');
var $01f60deec1a7fee5$var$$Object = Object;
var $01f60deec1a7fee5$var$ObjectPrototype = $01f60deec1a7fee5$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$01f60deec1a7fee5$exports = $ec6e227787d168e3$exports ? $01f60deec1a7fee5$var$$Object.getPrototypeOf : function(O) {
    var object = $d4c1256ef47a4432$exports(O);
    if ($44f04f053c39977d$exports(object, $01f60deec1a7fee5$var$IE_PROTO)) return object[$01f60deec1a7fee5$var$IE_PROTO];
    var constructor = object.constructor;
    if ($d3b5c54e0efe4919$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $01f60deec1a7fee5$var$$Object ? $01f60deec1a7fee5$var$ObjectPrototype : null;
};


var $f02d4f7320b8a22d$exports = {};
'use strict';
var $4704b64a2df2f1a8$exports = {};
'use strict';


$4704b64a2df2f1a8$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $4a940c070be3b3fa$exports($a2ba8ab9c7ca0870$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $6039b5085bf7c31b$exports = {};
'use strict';
var $6ed130616f06750d$exports = {};
'use strict';

$6ed130616f06750d$exports = function(argument) {
    return $b5ebf59d5dccfd91$exports(argument) || argument === null;
};


var $6039b5085bf7c31b$var$$String = String;
var $6039b5085bf7c31b$var$$TypeError = TypeError;
$6039b5085bf7c31b$exports = function(argument) {
    if ($6ed130616f06750d$exports(argument)) return argument;
    throw new $6039b5085bf7c31b$var$$TypeError("Can't set " + $6039b5085bf7c31b$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$f02d4f7320b8a22d$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $4704b64a2df2f1a8$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $09e988ba29a98f9f$exports(O);
        $6039b5085bf7c31b$exports(proto);
        if (!$b5ebf59d5dccfd91$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $6b44d9a5e116ad16$var$enforceInternalState = $d8e7bce4c49bb817$exports.enforce;
var $6b44d9a5e116ad16$var$getInternalState = $d8e7bce4c49bb817$exports.get;
var $6b44d9a5e116ad16$var$Int8Array = $02854e3ff22e2a55$exports.Int8Array;
var $6b44d9a5e116ad16$var$Int8ArrayPrototype = $6b44d9a5e116ad16$var$Int8Array && $6b44d9a5e116ad16$var$Int8Array.prototype;
var $6b44d9a5e116ad16$var$Uint8ClampedArray = $02854e3ff22e2a55$exports.Uint8ClampedArray;
var $6b44d9a5e116ad16$var$Uint8ClampedArrayPrototype = $6b44d9a5e116ad16$var$Uint8ClampedArray && $6b44d9a5e116ad16$var$Uint8ClampedArray.prototype;
var $6b44d9a5e116ad16$var$TypedArray = $6b44d9a5e116ad16$var$Int8Array && $01f60deec1a7fee5$exports($6b44d9a5e116ad16$var$Int8Array);
var $6b44d9a5e116ad16$var$TypedArrayPrototype = $6b44d9a5e116ad16$var$Int8ArrayPrototype && $01f60deec1a7fee5$exports($6b44d9a5e116ad16$var$Int8ArrayPrototype);
var $6b44d9a5e116ad16$var$ObjectPrototype = Object.prototype;
var $6b44d9a5e116ad16$var$TypeError = $02854e3ff22e2a55$exports.TypeError;
var $6b44d9a5e116ad16$var$TO_STRING_TAG = $4070132752d4af22$exports('toStringTag');
var $6b44d9a5e116ad16$var$TYPED_ARRAY_TAG = $abec29a2cb7de69c$exports('TYPED_ARRAY_TAG');
var $6b44d9a5e116ad16$var$TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS = $fb81e91581bab94d$exports && !!$f02d4f7320b8a22d$exports && $39a5e64497965203$exports($02854e3ff22e2a55$exports.opera) !== 'Opera';
var $6b44d9a5e116ad16$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $6b44d9a5e116ad16$var$NAME, $6b44d9a5e116ad16$var$Constructor, $6b44d9a5e116ad16$var$Prototype;
var $6b44d9a5e116ad16$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $6b44d9a5e116ad16$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $6b44d9a5e116ad16$var$isView = function isView(it) {
    if (!$b5ebf59d5dccfd91$exports(it)) return false;
    var klass = $39a5e64497965203$exports(it);
    return klass === 'DataView' || $44f04f053c39977d$exports($6b44d9a5e116ad16$var$TypedArrayConstructorsList, klass) || $44f04f053c39977d$exports($6b44d9a5e116ad16$var$BigIntArrayConstructorsList, klass);
};
var $6b44d9a5e116ad16$var$getTypedArrayConstructor = function(it) {
    var proto = $01f60deec1a7fee5$exports(it);
    if (!$b5ebf59d5dccfd91$exports(proto)) return;
    var state = $6b44d9a5e116ad16$var$getInternalState(proto);
    return state && $44f04f053c39977d$exports(state, $6b44d9a5e116ad16$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$6b44d9a5e116ad16$var$TYPED_ARRAY_CONSTRUCTOR] : $6b44d9a5e116ad16$var$getTypedArrayConstructor(proto);
};
var $6b44d9a5e116ad16$var$isTypedArray = function(it) {
    if (!$b5ebf59d5dccfd91$exports(it)) return false;
    var klass = $39a5e64497965203$exports(it);
    return $44f04f053c39977d$exports($6b44d9a5e116ad16$var$TypedArrayConstructorsList, klass) || $44f04f053c39977d$exports($6b44d9a5e116ad16$var$BigIntArrayConstructorsList, klass);
};
var $6b44d9a5e116ad16$var$aTypedArray = function(it) {
    if ($6b44d9a5e116ad16$var$isTypedArray(it)) return it;
    throw new $6b44d9a5e116ad16$var$TypeError('Target is not a typed array');
};
var $6b44d9a5e116ad16$var$aTypedArrayConstructor = function(C) {
    if ($d3b5c54e0efe4919$exports(C) && (!$f02d4f7320b8a22d$exports || $082e275852b092c6$exports($6b44d9a5e116ad16$var$TypedArray, C))) return C;
    throw new $6b44d9a5e116ad16$var$TypeError($3c5c57d684aab1bf$exports(C) + ' is not a typed array constructor');
};
var $6b44d9a5e116ad16$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$5e9b0df860d70ad6$exports) return;
    if (forced) for(var ARRAY in $6b44d9a5e116ad16$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $02854e3ff22e2a55$exports[ARRAY];
        if (TypedArrayConstructor && $44f04f053c39977d$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$6b44d9a5e116ad16$var$TypedArrayPrototype[KEY] || forced) $ed089d2627805a57$exports($6b44d9a5e116ad16$var$TypedArrayPrototype, KEY, forced ? property : $6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS && $6b44d9a5e116ad16$var$Int8ArrayPrototype[KEY] || property, options);
};
var $6b44d9a5e116ad16$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$5e9b0df860d70ad6$exports) return;
    if ($f02d4f7320b8a22d$exports) {
        if (forced) for(ARRAY in $6b44d9a5e116ad16$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $02854e3ff22e2a55$exports[ARRAY];
            if (TypedArrayConstructor && $44f04f053c39977d$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$6b44d9a5e116ad16$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $ed089d2627805a57$exports($6b44d9a5e116ad16$var$TypedArray, KEY, forced ? property : $6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS && $6b44d9a5e116ad16$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $6b44d9a5e116ad16$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $02854e3ff22e2a55$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $ed089d2627805a57$exports(TypedArrayConstructor, KEY, property);
    }
};
for($6b44d9a5e116ad16$var$NAME in $6b44d9a5e116ad16$var$TypedArrayConstructorsList){
    $6b44d9a5e116ad16$var$Constructor = $02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME];
    $6b44d9a5e116ad16$var$Prototype = $6b44d9a5e116ad16$var$Constructor && $6b44d9a5e116ad16$var$Constructor.prototype;
    if ($6b44d9a5e116ad16$var$Prototype) $6b44d9a5e116ad16$var$enforceInternalState($6b44d9a5e116ad16$var$Prototype)[$6b44d9a5e116ad16$var$TYPED_ARRAY_CONSTRUCTOR] = $6b44d9a5e116ad16$var$Constructor;
    else $6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($6b44d9a5e116ad16$var$NAME in $6b44d9a5e116ad16$var$BigIntArrayConstructorsList){
    $6b44d9a5e116ad16$var$Constructor = $02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME];
    $6b44d9a5e116ad16$var$Prototype = $6b44d9a5e116ad16$var$Constructor && $6b44d9a5e116ad16$var$Constructor.prototype;
    if ($6b44d9a5e116ad16$var$Prototype) $6b44d9a5e116ad16$var$enforceInternalState($6b44d9a5e116ad16$var$Prototype)[$6b44d9a5e116ad16$var$TYPED_ARRAY_CONSTRUCTOR] = $6b44d9a5e116ad16$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS || !$d3b5c54e0efe4919$exports($6b44d9a5e116ad16$var$TypedArray) || $6b44d9a5e116ad16$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $6b44d9a5e116ad16$var$TypedArray = function TypedArray() {
        throw new $6b44d9a5e116ad16$var$TypeError('Incorrect invocation');
    };
    if ($6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($6b44d9a5e116ad16$var$NAME in $6b44d9a5e116ad16$var$TypedArrayConstructorsList)if ($02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME]) $f02d4f7320b8a22d$exports($02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME], $6b44d9a5e116ad16$var$TypedArray);
    }
}
if (!$6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS || !$6b44d9a5e116ad16$var$TypedArrayPrototype || $6b44d9a5e116ad16$var$TypedArrayPrototype === $6b44d9a5e116ad16$var$ObjectPrototype) {
    $6b44d9a5e116ad16$var$TypedArrayPrototype = $6b44d9a5e116ad16$var$TypedArray.prototype;
    if ($6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($6b44d9a5e116ad16$var$NAME in $6b44d9a5e116ad16$var$TypedArrayConstructorsList)if ($02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME]) $f02d4f7320b8a22d$exports($02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME].prototype, $6b44d9a5e116ad16$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS && $01f60deec1a7fee5$exports($6b44d9a5e116ad16$var$Uint8ClampedArrayPrototype) !== $6b44d9a5e116ad16$var$TypedArrayPrototype) $f02d4f7320b8a22d$exports($6b44d9a5e116ad16$var$Uint8ClampedArrayPrototype, $6b44d9a5e116ad16$var$TypedArrayPrototype);
if ($5e9b0df860d70ad6$exports && !$44f04f053c39977d$exports($6b44d9a5e116ad16$var$TypedArrayPrototype, $6b44d9a5e116ad16$var$TO_STRING_TAG)) {
    $6b44d9a5e116ad16$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $42a99fbba5c80341$exports($6b44d9a5e116ad16$var$TypedArrayPrototype, $6b44d9a5e116ad16$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $b5ebf59d5dccfd91$exports(this) ? this[$6b44d9a5e116ad16$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($6b44d9a5e116ad16$var$NAME in $6b44d9a5e116ad16$var$TypedArrayConstructorsList)if ($02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME]) $4bb99da2275f3503$exports($02854e3ff22e2a55$exports[$6b44d9a5e116ad16$var$NAME], $6b44d9a5e116ad16$var$TYPED_ARRAY_TAG, $6b44d9a5e116ad16$var$NAME);
}
$6b44d9a5e116ad16$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $6b44d9a5e116ad16$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $6b44d9a5e116ad16$var$TYPED_ARRAY_TAG_REQUIRED && $6b44d9a5e116ad16$var$TYPED_ARRAY_TAG,
    aTypedArray: $6b44d9a5e116ad16$var$aTypedArray,
    aTypedArrayConstructor: $6b44d9a5e116ad16$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $6b44d9a5e116ad16$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $6b44d9a5e116ad16$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $6b44d9a5e116ad16$var$getTypedArrayConstructor,
    isView: $6b44d9a5e116ad16$var$isView,
    isTypedArray: $6b44d9a5e116ad16$var$isTypedArray,
    TypedArray: $6b44d9a5e116ad16$var$TypedArray,
    TypedArrayPrototype: $6b44d9a5e116ad16$var$TypedArrayPrototype
};


var $d69ee7eb46f76a13$exports = {};
'use strict';
var $e35fc421e55febe7$exports = {};
'use strict';
var $2d259a839b571440$exports = {};
'use strict';
var $532ae2c252b66f67$exports = {};
'use strict';
var $532ae2c252b66f67$var$ceil = Math.ceil;
var $532ae2c252b66f67$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$532ae2c252b66f67$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $532ae2c252b66f67$var$floor : $532ae2c252b66f67$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$2d259a839b571440$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $532ae2c252b66f67$exports(number);
};


var $e35fc421e55febe7$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$e35fc421e55febe7$exports = function(argument) {
    var len = $2d259a839b571440$exports(argument);
    return len > 0 ? $e35fc421e55febe7$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$d69ee7eb46f76a13$exports = function(obj) {
    return $e35fc421e55febe7$exports(obj.length);
};


var $c426c2affa378232$exports = {};
'use strict';
var $faea38ad3082bf3f$exports = {};
'use strict';

var $faea38ad3082bf3f$var$$RangeError = RangeError;
$faea38ad3082bf3f$exports = function(it) {
    var result = $2d259a839b571440$exports(it);
    if (result < 0) throw new $faea38ad3082bf3f$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $c426c2affa378232$var$$RangeError = RangeError;
$c426c2affa378232$exports = function(it, BYTES) {
    var offset = $faea38ad3082bf3f$exports(it);
    if (offset % BYTES) throw new $c426c2affa378232$var$$RangeError('Wrong offset');
    return offset;
};




var $4b54ed7bfb12f1c8$var$RangeError = $02854e3ff22e2a55$exports.RangeError;
var $4b54ed7bfb12f1c8$var$Int8Array = $02854e3ff22e2a55$exports.Int8Array;
var $4b54ed7bfb12f1c8$var$Int8ArrayPrototype = $4b54ed7bfb12f1c8$var$Int8Array && $4b54ed7bfb12f1c8$var$Int8Array.prototype;
var $4b54ed7bfb12f1c8$var$$set = $4b54ed7bfb12f1c8$var$Int8ArrayPrototype && $4b54ed7bfb12f1c8$var$Int8ArrayPrototype.set;
var $4b54ed7bfb12f1c8$var$aTypedArray = $6b44d9a5e116ad16$exports.aTypedArray;
var $4b54ed7bfb12f1c8$var$exportTypedArrayMethod = $6b44d9a5e116ad16$exports.exportTypedArrayMethod;
var $4b54ed7bfb12f1c8$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$dcdc9b526aa3d25a$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $24f8e13787a29057$exports($4b54ed7bfb12f1c8$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $4b54ed7bfb12f1c8$var$TO_OBJECT_BUG = $4b54ed7bfb12f1c8$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $6b44d9a5e116ad16$exports.NATIVE_ARRAY_BUFFER_VIEWS && $dcdc9b526aa3d25a$exports(function() {
    var array = new $4b54ed7bfb12f1c8$var$Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$4b54ed7bfb12f1c8$var$exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    $4b54ed7bfb12f1c8$var$aTypedArray(this);
    var offset = $c426c2affa378232$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $d4c1256ef47a4432$exports(arrayLike);
    if ($4b54ed7bfb12f1c8$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $24f8e13787a29057$exports($4b54ed7bfb12f1c8$var$$set, this, src, offset);
    var length = this.length;
    var len = $d69ee7eb46f76a13$exports(src);
    var index = 0;
    if (len + offset > length) throw new $4b54ed7bfb12f1c8$var$RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !$4b54ed7bfb12f1c8$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $4b54ed7bfb12f1c8$var$TO_OBJECT_BUG);


'use strict';
'use strict';
var $b766c04498698484$exports = {};
'use strict';

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $79676bef84003a1c$export$2d1720544b23b823;
'use strict';


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $48842848c3e197b3$export$2d1720544b23b823;
'use strict';
var $48842848c3e197b3$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $48842848c3e197b3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $48842848c3e197b3$var$NASHORN_BUG = $48842848c3e197b3$var$getOwnPropertyDescriptor && !$48842848c3e197b3$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$48842848c3e197b3$export$2d1720544b23b823 = $48842848c3e197b3$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $48842848c3e197b3$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $48842848c3e197b3$var$$propertyIsEnumerable;



var $6d66bbdff6d84546$exports = {};
'use strict';
var $5b2eb9f5186a3238$exports = {};
'use strict';



var $5b2eb9f5186a3238$var$$Object = Object;
var $5b2eb9f5186a3238$var$split = $4a940c070be3b3fa$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$5b2eb9f5186a3238$exports = $dcdc9b526aa3d25a$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$5b2eb9f5186a3238$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $152aec1d51d07892$exports(it) === 'String' ? $5b2eb9f5186a3238$var$split(it, '') : $5b2eb9f5186a3238$var$$Object(it);
} : $5b2eb9f5186a3238$var$$Object;



$6d66bbdff6d84546$exports = function(it) {
    return $5b2eb9f5186a3238$exports($09e988ba29a98f9f$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $79676bef84003a1c$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$79676bef84003a1c$export$2d1720544b23b823 = $5e9b0df860d70ad6$exports ? $79676bef84003a1c$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $6d66bbdff6d84546$exports(O);
    P = $e22b43ffdc0ae7fb$exports(P);
    if ($a12e0a77a176b2e4$exports) try {
        return $79676bef84003a1c$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($44f04f053c39977d$exports(O, P)) return $cfed81556fccc500$exports(!$24f8e13787a29057$exports($48842848c3e197b3$export$2d1720544b23b823, O, P), O[P]);
};


var $b766c04498698484$require$getOwnPropertyDescriptor = $79676bef84003a1c$export$2d1720544b23b823;



var $f3ff2cbbf33e03f3$exports = {};
'use strict';

var $d885e5453443dfaf$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $a4e23191e1edc7e7$export$2d1720544b23b823;
'use strict';
var $a5e0d9477f0c112b$exports = {};
'use strict';



var $a09fae79a0566969$exports = {};
'use strict';

var $39ad3b8a784bdf5b$exports = {};
'use strict';

var $39ad3b8a784bdf5b$var$max = Math.max;
var $39ad3b8a784bdf5b$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$39ad3b8a784bdf5b$exports = function(index, length) {
    var integer = $2d259a839b571440$exports(index);
    return integer < 0 ? $39ad3b8a784bdf5b$var$max(integer + length, 0) : $39ad3b8a784bdf5b$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $a09fae79a0566969$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6d66bbdff6d84546$exports($this);
        var length = $d69ee7eb46f76a13$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $39ad3b8a784bdf5b$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$a09fae79a0566969$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $a09fae79a0566969$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $a09fae79a0566969$var$createMethod(false)
};


var $a5e0d9477f0c112b$require$indexOf = $a09fae79a0566969$exports.indexOf;

var $a5e0d9477f0c112b$var$push = $4a940c070be3b3fa$exports([].push);
$a5e0d9477f0c112b$exports = function(object, names) {
    var O = $6d66bbdff6d84546$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$44f04f053c39977d$exports($5da105f505494238$exports, key) && $44f04f053c39977d$exports(O, key) && $a5e0d9477f0c112b$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($44f04f053c39977d$exports(O, key = names[i++])) ~$a5e0d9477f0c112b$require$indexOf(result, key) || $a5e0d9477f0c112b$var$push(result, key);
    return result;
};


var $3678d6685d6dfab9$exports = {};
'use strict';
// IE8- don't enum bug keys
$3678d6685d6dfab9$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $a4e23191e1edc7e7$var$hiddenKeys = $3678d6685d6dfab9$exports.concat('length', 'prototype');
$a4e23191e1edc7e7$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $a5e0d9477f0c112b$exports(O, $a4e23191e1edc7e7$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $1238ef2b3d4f5f5d$export$2d1720544b23b823;
'use strict';
$1238ef2b3d4f5f5d$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $d885e5453443dfaf$var$concat = $4a940c070be3b3fa$exports([].concat);
// all object keys, includes non-enumerable and symbols
$d885e5453443dfaf$exports = $6b8917f51b0da2d4$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $a4e23191e1edc7e7$export$2d1720544b23b823($230d61f7a8553bc0$exports(it));
    var getOwnPropertySymbols = $1238ef2b3d4f5f5d$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $d885e5453443dfaf$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$f3ff2cbbf33e03f3$exports = function(target, source, exceptions) {
    var keys = $d885e5453443dfaf$exports(source);
    var defineProperty = $7e4e8568fa191380$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $79676bef84003a1c$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$44f04f053c39977d$exports(target, key) && !(exceptions && $44f04f053c39977d$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $3e48991cae24974c$exports = {};
'use strict';


var $3e48991cae24974c$var$replacement = /#|\.prototype\./;
var $3e48991cae24974c$var$isForced = function(feature, detection) {
    var value = $3e48991cae24974c$var$data[$3e48991cae24974c$var$normalize(feature)];
    return value === $3e48991cae24974c$var$POLYFILL ? true : value === $3e48991cae24974c$var$NATIVE ? false : $d3b5c54e0efe4919$exports(detection) ? $dcdc9b526aa3d25a$exports(detection) : !!detection;
};
var $3e48991cae24974c$var$normalize = $3e48991cae24974c$var$isForced.normalize = function(string) {
    return String(string).replace($3e48991cae24974c$var$replacement, '.').toLowerCase();
};
var $3e48991cae24974c$var$data = $3e48991cae24974c$var$isForced.data = {};
var $3e48991cae24974c$var$NATIVE = $3e48991cae24974c$var$isForced.NATIVE = 'N';
var $3e48991cae24974c$var$POLYFILL = $3e48991cae24974c$var$isForced.POLYFILL = 'P';
$3e48991cae24974c$exports = $3e48991cae24974c$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $b766c04498698484$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $02854e3ff22e2a55$exports;
    else if (STATIC) target = $02854e3ff22e2a55$exports[TARGET] || $442d0e1485853cf0$exports(TARGET, {});
    else target = $02854e3ff22e2a55$exports[TARGET] && $02854e3ff22e2a55$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $b766c04498698484$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $3e48991cae24974c$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $f3ff2cbbf33e03f3$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $4bb99da2275f3503$exports(sourceProperty, 'sham', true);
        $ed089d2627805a57$exports(target, key, sourceProperty, options);
    }
};



var $27ec7ee9245ebeb2$exports = {};
'use strict';

var $4c5a7d7f99427804$exports = {};
'use strict';

var $4c5a7d7f99427804$var$FunctionPrototype = Function.prototype;
var $4c5a7d7f99427804$var$apply = $4c5a7d7f99427804$var$FunctionPrototype.apply;
var $4c5a7d7f99427804$var$call = $4c5a7d7f99427804$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$4c5a7d7f99427804$exports = typeof Reflect == 'object' && Reflect.apply || ($d032db0c6aa5b506$exports ? $4c5a7d7f99427804$var$call.bind($4c5a7d7f99427804$var$apply) : function() {
    return $4c5a7d7f99427804$var$call.apply($4c5a7d7f99427804$var$apply, arguments);
});


var $ed2dc884babfdc64$exports = {};
'use strict';
var $ca7f25f34a532e11$exports = {};
'use strict';


$ca7f25f34a532e11$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($152aec1d51d07892$exports(fn) === 'Function') return $4a940c070be3b3fa$exports(fn);
};




var $ed2dc884babfdc64$var$bind = $ca7f25f34a532e11$exports($ca7f25f34a532e11$exports.bind);
// optional / simple context binding
$ed2dc884babfdc64$exports = function(fn, that) {
    $a2ba8ab9c7ca0870$exports(fn);
    return that === undefined ? fn : $d032db0c6aa5b506$exports ? $ed2dc884babfdc64$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $931c68d414db2766$exports = {};
'use strict';

$931c68d414db2766$exports = $6b8917f51b0da2d4$exports('document', 'documentElement');


var $833acea23f4451d3$exports = {};
'use strict';

$833acea23f4451d3$exports = $4a940c070be3b3fa$exports([].slice);



var $62f8ce718cb176d4$exports = {};
'use strict';
var $62f8ce718cb176d4$var$$TypeError = TypeError;
$62f8ce718cb176d4$exports = function(passed, required) {
    if (passed < required) throw new $62f8ce718cb176d4$var$$TypeError('Not enough arguments');
    return passed;
};


var $036ae70f8f0d87de$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$036ae70f8f0d87de$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($4650ad1f1223221a$exports);


var $1ac3bd71ecc3c5b3$exports = {};
'use strict';
var $eece604e02cc2c14$exports = {};
'use strict';



var $eece604e02cc2c14$var$userAgentStartsWith = function(string) {
    return $4650ad1f1223221a$exports.slice(0, string.length) === string;
};
$eece604e02cc2c14$exports = function() {
    if ($eece604e02cc2c14$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($eece604e02cc2c14$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($eece604e02cc2c14$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($eece604e02cc2c14$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($02854e3ff22e2a55$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($02854e3ff22e2a55$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($152aec1d51d07892$exports($02854e3ff22e2a55$exports.process) === 'process') return 'NODE';
    if ($02854e3ff22e2a55$exports.window && $02854e3ff22e2a55$exports.document) return 'BROWSER';
    return 'REST';
}();


$1ac3bd71ecc3c5b3$exports = $eece604e02cc2c14$exports === 'NODE';


var $27ec7ee9245ebeb2$var$set = $02854e3ff22e2a55$exports.setImmediate;
var $27ec7ee9245ebeb2$var$clear = $02854e3ff22e2a55$exports.clearImmediate;
var $27ec7ee9245ebeb2$var$process = $02854e3ff22e2a55$exports.process;
var $27ec7ee9245ebeb2$var$Dispatch = $02854e3ff22e2a55$exports.Dispatch;
var $27ec7ee9245ebeb2$var$Function = $02854e3ff22e2a55$exports.Function;
var $27ec7ee9245ebeb2$var$MessageChannel = $02854e3ff22e2a55$exports.MessageChannel;
var $27ec7ee9245ebeb2$var$String = $02854e3ff22e2a55$exports.String;
var $27ec7ee9245ebeb2$var$counter = 0;
var $27ec7ee9245ebeb2$var$queue = {};
var $27ec7ee9245ebeb2$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $27ec7ee9245ebeb2$var$$location, $27ec7ee9245ebeb2$var$defer, $27ec7ee9245ebeb2$var$channel, $27ec7ee9245ebeb2$var$port;
$dcdc9b526aa3d25a$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $27ec7ee9245ebeb2$var$$location = $02854e3ff22e2a55$exports.location;
});
var $27ec7ee9245ebeb2$var$run = function(id) {
    if ($44f04f053c39977d$exports($27ec7ee9245ebeb2$var$queue, id)) {
        var fn = $27ec7ee9245ebeb2$var$queue[id];
        delete $27ec7ee9245ebeb2$var$queue[id];
        fn();
    }
};
var $27ec7ee9245ebeb2$var$runner = function(id) {
    return function() {
        $27ec7ee9245ebeb2$var$run(id);
    };
};
var $27ec7ee9245ebeb2$var$eventListener = function(event) {
    $27ec7ee9245ebeb2$var$run(event.data);
};
var $27ec7ee9245ebeb2$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $02854e3ff22e2a55$exports.postMessage($27ec7ee9245ebeb2$var$String(id), $27ec7ee9245ebeb2$var$$location.protocol + '//' + $27ec7ee9245ebeb2$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$27ec7ee9245ebeb2$var$set || !$27ec7ee9245ebeb2$var$clear) {
    $27ec7ee9245ebeb2$var$set = function setImmediate(handler) {
        $62f8ce718cb176d4$exports(arguments.length, 1);
        var fn = $d3b5c54e0efe4919$exports(handler) ? handler : $27ec7ee9245ebeb2$var$Function(handler);
        var args = $833acea23f4451d3$exports(arguments, 1);
        $27ec7ee9245ebeb2$var$queue[++$27ec7ee9245ebeb2$var$counter] = function() {
            $4c5a7d7f99427804$exports(fn, undefined, args);
        };
        $27ec7ee9245ebeb2$var$defer($27ec7ee9245ebeb2$var$counter);
        return $27ec7ee9245ebeb2$var$counter;
    };
    $27ec7ee9245ebeb2$var$clear = function clearImmediate(id) {
        delete $27ec7ee9245ebeb2$var$queue[id];
    };
    // Node.js 0.8-
    if ($1ac3bd71ecc3c5b3$exports) $27ec7ee9245ebeb2$var$defer = function(id) {
        $27ec7ee9245ebeb2$var$process.nextTick($27ec7ee9245ebeb2$var$runner(id));
    };
    else if ($27ec7ee9245ebeb2$var$Dispatch && $27ec7ee9245ebeb2$var$Dispatch.now) $27ec7ee9245ebeb2$var$defer = function(id) {
        $27ec7ee9245ebeb2$var$Dispatch.now($27ec7ee9245ebeb2$var$runner(id));
    };
    else if ($27ec7ee9245ebeb2$var$MessageChannel && !$036ae70f8f0d87de$exports) {
        $27ec7ee9245ebeb2$var$channel = new $27ec7ee9245ebeb2$var$MessageChannel();
        $27ec7ee9245ebeb2$var$port = $27ec7ee9245ebeb2$var$channel.port2;
        $27ec7ee9245ebeb2$var$channel.port1.onmessage = $27ec7ee9245ebeb2$var$eventListener;
        $27ec7ee9245ebeb2$var$defer = $ed2dc884babfdc64$exports($27ec7ee9245ebeb2$var$port.postMessage, $27ec7ee9245ebeb2$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($02854e3ff22e2a55$exports.addEventListener && $d3b5c54e0efe4919$exports($02854e3ff22e2a55$exports.postMessage) && !$02854e3ff22e2a55$exports.importScripts && $27ec7ee9245ebeb2$var$$location && $27ec7ee9245ebeb2$var$$location.protocol !== 'file:' && !$dcdc9b526aa3d25a$exports($27ec7ee9245ebeb2$var$globalPostMessageDefer)) {
        $27ec7ee9245ebeb2$var$defer = $27ec7ee9245ebeb2$var$globalPostMessageDefer;
        $02854e3ff22e2a55$exports.addEventListener('message', $27ec7ee9245ebeb2$var$eventListener, false);
    // IE8-
    } else if ($27ec7ee9245ebeb2$var$ONREADYSTATECHANGE in $ab2fc4bb10b030dd$exports('script')) $27ec7ee9245ebeb2$var$defer = function(id) {
        $931c68d414db2766$exports.appendChild($ab2fc4bb10b030dd$exports('script'))[$27ec7ee9245ebeb2$var$ONREADYSTATECHANGE] = function() {
            $931c68d414db2766$exports.removeChild(this);
            $27ec7ee9245ebeb2$var$run(id);
        };
    };
    else $27ec7ee9245ebeb2$var$defer = function(id) {
        setTimeout($27ec7ee9245ebeb2$var$runner(id), 0);
    };
}
$27ec7ee9245ebeb2$exports = {
    set: $27ec7ee9245ebeb2$var$set,
    clear: $27ec7ee9245ebeb2$var$clear
};


var $a1bd7370a41c3e5f$require$clearImmediate = $27ec7ee9245ebeb2$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$b766c04498698484$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $02854e3ff22e2a55$exports.clearImmediate !== $a1bd7370a41c3e5f$require$clearImmediate
}, {
    clearImmediate: $a1bd7370a41c3e5f$require$clearImmediate
});


'use strict';



var $e5264126a1f9db2f$require$setTask = $27ec7ee9245ebeb2$exports.set;
var $e1595d46e1b77c2c$exports = {};
'use strict';







var $e1595d46e1b77c2c$var$Function = $02854e3ff22e2a55$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $e1595d46e1b77c2c$var$WRAP = /MSIE .\./.test($4650ad1f1223221a$exports) || $eece604e02cc2c14$exports === 'BUN' && function() {
    var version = $02854e3ff22e2a55$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$e1595d46e1b77c2c$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $e1595d46e1b77c2c$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $62f8ce718cb176d4$exports(arguments.length, 1) > firstParamIndex;
        var fn = $d3b5c54e0efe4919$exports(handler) ? handler : $e1595d46e1b77c2c$var$Function(handler);
        var params = boundArgs ? $833acea23f4451d3$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $4c5a7d7f99427804$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e5264126a1f9db2f$var$setImmediate = $02854e3ff22e2a55$exports.setImmediate ? $e1595d46e1b77c2c$exports($e5264126a1f9db2f$require$setTask, false) : $e5264126a1f9db2f$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$b766c04498698484$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $02854e3ff22e2a55$exports.setImmediate !== $e5264126a1f9db2f$var$setImmediate
}, {
    setImmediate: $e5264126a1f9db2f$var$setImmediate
});




var $773f306c72081eb0$export$402e76927ebf6a24 = [];


var $8543165444a65fc9$export$63c81bd924f89474 = function() {
    return (0, $773f306c72081eb0$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $c4f9f1137f6e13ac$export$8ca35300535e324d = function() {
    return (0, $773f306c72081eb0$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $bb276c1ee31c2960$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $bb276c1ee31c2960$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $bb276c1ee31c2960$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $bb276c1ee31c2960$var$msg;
    }
    window.dispatchEvent(event);
};



var $c69163540c38fed2$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($c69163540c38fed2$export$416d111b83cd1483 || ($c69163540c38fed2$export$416d111b83cd1483 = {}));


var $e1d898ddcbbb5821$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $60bf3d13cbb1f14b$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $fd29b0b01d8c00f5$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $98673a5a5892992a$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $98673a5a5892992a$export$ee695c13482bb5dd = function(target) {
    if ($98673a5a5892992a$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $98673a5a5892992a$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $98673a5a5892992a$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $2b3ed3a5d3e743f0$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $41d8a9049a541b3f$var$cache = new WeakMap();
var $41d8a9049a541b3f$var$scrollRegexp = /auto|scroll/;
var $41d8a9049a541b3f$var$verticalRegexp = /^tb|vertical/;
var $41d8a9049a541b3f$var$IE = /msie|trident/i.test((0, $2b3ed3a5d3e743f0$export$90b4d2ff6acb88af).navigator && (0, $2b3ed3a5d3e743f0$export$90b4d2ff6acb88af).navigator.userAgent);
var $41d8a9049a541b3f$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $41d8a9049a541b3f$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $60bf3d13cbb1f14b$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $41d8a9049a541b3f$var$zeroBoxes = (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $41d8a9049a541b3f$var$size(),
    borderBoxSize: $41d8a9049a541b3f$var$size(),
    contentBoxSize: $41d8a9049a541b3f$var$size(),
    contentRect: new (0, $fd29b0b01d8c00f5$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $41d8a9049a541b3f$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($41d8a9049a541b3f$var$cache.has(target) && !forceRecalculation) return $41d8a9049a541b3f$var$cache.get(target);
    if ((0, $98673a5a5892992a$export$ee695c13482bb5dd)(target)) {
        $41d8a9049a541b3f$var$cache.set(target, $41d8a9049a541b3f$var$zeroBoxes);
        return $41d8a9049a541b3f$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $98673a5a5892992a$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$41d8a9049a541b3f$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $41d8a9049a541b3f$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $41d8a9049a541b3f$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $41d8a9049a541b3f$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $41d8a9049a541b3f$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $41d8a9049a541b3f$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $41d8a9049a541b3f$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $41d8a9049a541b3f$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $41d8a9049a541b3f$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $41d8a9049a541b3f$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $fd29b0b01d8c00f5$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $41d8a9049a541b3f$var$cache.set(target, boxes);
    return boxes;
};
var $41d8a9049a541b3f$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $41d8a9049a541b3f$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $c69163540c38fed2$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $c69163540c38fed2$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $8e7cd8bce72387e9$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $41d8a9049a541b3f$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $e1d898ddcbbb5821$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $33cdd09686b298cd$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $98673a5a5892992a$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $67f8729f93083d6e$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $773f306c72081eb0$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $8e7cd8bce72387e9$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $33cdd09686b298cd$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $41d8a9049a541b3f$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $c5a8a45c50b940e8$export$9c17b8913a2a3572 = function(depth) {
    (0, $773f306c72081eb0$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $33cdd09686b298cd$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $091f990e0b792256$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $c5a8a45c50b940e8$export$9c17b8913a2a3572)(depth);
    while((0, $8543165444a65fc9$export$63c81bd924f89474)()){
        depth = (0, $67f8729f93083d6e$export$9cac928141e5443b)();
        (0, $c5a8a45c50b940e8$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $c4f9f1137f6e13ac$export$8ca35300535e324d)()) (0, $bb276c1ee31c2960$export$888cb69481582149)();
    return depth > 0;
};



var $27bc20bfae31586d$var$trigger;
var $27bc20bfae31586d$var$callbacks = [];
var $27bc20bfae31586d$var$notify = function() {
    return $27bc20bfae31586d$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $27bc20bfae31586d$export$4c995d4933c4abb = function(callback) {
    if (!$27bc20bfae31586d$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $27bc20bfae31586d$var$notify();
        }).observe(el_1, config);
        $27bc20bfae31586d$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $27bc20bfae31586d$var$callbacks.push(callback);
    $27bc20bfae31586d$var$trigger();
};


var $1d4efd9858e0297e$export$5755c7b572e34c6 = function(cb) {
    (0, $27bc20bfae31586d$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $2894da349ffe7bde$var$watching = 0;
var $2894da349ffe7bde$var$isWatching = function() {
    return !!$2894da349ffe7bde$var$watching;
};
var $2894da349ffe7bde$var$CATCH_PERIOD = 250;
var $2894da349ffe7bde$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $2894da349ffe7bde$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $2894da349ffe7bde$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $2894da349ffe7bde$var$scheduled = false;
var $2894da349ffe7bde$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $2894da349ffe7bde$var$CATCH_PERIOD;
        if ($2894da349ffe7bde$var$scheduled) return;
        $2894da349ffe7bde$var$scheduled = true;
        var until = $2894da349ffe7bde$var$time(timeout);
        (0, $1d4efd9858e0297e$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $091f990e0b792256$export$e54fe5b0f43758f7)();
            } finally{
                $2894da349ffe7bde$var$scheduled = false;
                timeout = until - $2894da349ffe7bde$var$time();
                if (!$2894da349ffe7bde$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $2894da349ffe7bde$var$observerConfig);
        };
        document.body ? cb() : (0, $2b3ed3a5d3e743f0$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $2894da349ffe7bde$var$events.forEach(function(name) {
                return (0, $2b3ed3a5d3e743f0$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $2894da349ffe7bde$var$events.forEach(function(name) {
                return (0, $2b3ed3a5d3e743f0$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $2894da349ffe7bde$export$d30788f2c20241cd = new $2894da349ffe7bde$var$Scheduler();
var $2894da349ffe7bde$export$1f18a74d42722835 = function(n) {
    !$2894da349ffe7bde$var$watching && n > 0 && $2894da349ffe7bde$export$d30788f2c20241cd.start();
    $2894da349ffe7bde$var$watching += n;
    !$2894da349ffe7bde$var$watching && $2894da349ffe7bde$export$d30788f2c20241cd.stop();
};





var $f603a84caa2a7a8d$var$skipNotifyOnElement = function(target) {
    return !(0, $98673a5a5892992a$export$165b39ed277223c2)(target) && !(0, $98673a5a5892992a$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $f603a84caa2a7a8d$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $c69163540c38fed2$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $41d8a9049a541b3f$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($f603a84caa2a7a8d$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $e9ed6b122a0c7b6a$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $b245177ad3fe03d9$var$observerMap = new WeakMap();
var $b245177ad3fe03d9$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $b245177ad3fe03d9$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $e9ed6b122a0c7b6a$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $b245177ad3fe03d9$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $b245177ad3fe03d9$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($b245177ad3fe03d9$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $773f306c72081eb0$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $f603a84caa2a7a8d$export$fea412043713122)(target, options && options.box));
            (0, $2894da349ffe7bde$export$1f18a74d42722835)(1);
            (0, $2894da349ffe7bde$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $b245177ad3fe03d9$var$observerMap.get(resizeObserver);
        var index = $b245177ad3fe03d9$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $773f306c72081eb0$export$402e76927ebf6a24).splice((0, $773f306c72081eb0$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $2894da349ffe7bde$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $b245177ad3fe03d9$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $2cfbafcea7c779cd$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $b245177ad3fe03d9$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $98673a5a5892992a$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $b245177ad3fe03d9$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $98673a5a5892992a$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $b245177ad3fe03d9$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $b245177ad3fe03d9$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






var $46193eaa2cae4b41$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46193eaa2cae4b41$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $46193eaa2cae4b41$exports));
try {
    regeneratorRuntime = $46193eaa2cae4b41$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $46193eaa2cae4b41$var$runtime;
    else Function("r", "regeneratorRuntime = r")($46193eaa2cae4b41$var$runtime);
}


// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
if (!window.ResizeObserver) window.ResizeObserver = (0, $2cfbafcea7c779cd$export$9caf76241ca21a11);


//# sourceMappingURL=babel.polyfills.b07a6e89.js.map
